import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { DeleteWarningIcon } from "../../../../../components/ui/icons";
import useEnableDisablePublicApi from "./useEnableDisablePublicApi";

interface IProps {
  email: string;
  isApproved: boolean;
  orgId: string;
  displayName: string;
}

const EnableDisablePublicApi = ({ email, isApproved, orgId, displayName }: IProps) => {
  const {
    show,
    handleShow,
    handleClose,
    popupAction,
    popupTitle,
    handleToggle,
  } = useEnableDisablePublicApi({ email, isApproved, orgId });

  const isDisabling = isApproved;

  return (
    <>
      <Form.Check
        type="switch"
        id={`public-api-switch-${email}`}
        checked={isApproved}
        onChange={handleShow}
      />

      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container disable-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading d-flex align-items-center gap-2">
              {isDisabling && <DeleteWarningIcon />}
              <h1 className="mb-0">{popupTitle}</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to {popupAction.toLowerCase()} Public API
            access for <strong>{displayName}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={isDisabling ? "btn-delete" : "btn-style"}
            variant={isDisabling ? "danger" : "primary"}
            onClick={handleToggle}
          >
            {popupAction}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EnableDisablePublicApi;
